import React, { useContext } from "react";
import styles from "./modalHeader.module.css";
import { BurgerMenuContext } from "context/sidebar";


const ModalHeader = ({label="",cancelFunc=null }) =>{

  const burgerContext = useContext(BurgerMenuContext);

  const closeModal = () =>{
      burgerContext.updateComp(null)
      burgerContext.setShowSideBar(false)
  }

    return  <div className={styles.header}>
    <div className={styles.label}>
      {/* <img src="/icons/backArrow.svg" alt="Back Arrow" /> */}
      <span>{label}</span>
    </div>
    <img src="/icons/cancel.svg" className={styles.cancel} onClick={cancelFunc || closeModal} alt="Cancel" />
  </div>
}


export default React.memo(ModalHeader);